// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__WoLMn","label":"Textarea_label__b0sfK"};